import {BaseService} from './base'
import {timeFormat} from "../utils";
import {RENEWAL_ORDER_STATUS, RENEWAL_TYPE} from "../config";
import {sexFilter} from "../filters";
import {tokenCache} from "../../lib/cache/Token"

class RecipeService extends BaseService {
    constructor() {
        super();
    }

    /**
     * 获取药品列表
     * @param orderType
     * @param dosageForm
     * @param keyword
     * @returns {Promise<*>}
     */
    async getMedicine({orderType, dosageForm, keyword}) {
        let {code, list = []} = await this.$http("smarthos.recipe.drug.list.page", {
            orderType,
            dosageForm,
            keyword,
            token: tokenCache.get(),
        })
        if (code === '0') return list
    }

    /**
     * 处方详情
     * @param orderId
     * @returns {Promise<{}>}
     */
    async info(orderId) {
        const {code, obj} = await this.$http('smarthos.recipe.order.info', {
            orderId,
            token: tokenCache.get(),
        });
        return code === '0' ? this.handlerItem(obj) : {};
    }

    /**
     * 药品字典
     * @returns {Promise<{}>}
     */
    async drugDict() {
        const {code, obj} = await this.$http('smarthos.system.dict.drug.list', {
            token: tokenCache.get(),
        });
        return code === '0' ? obj : {};
    }


    /**
     * 拒绝续方
     * @param id
     * @param cancelReason
     * @returns {Promise<boolean>}
     */
    async refuse(id, cancelReason) {
        const {code} = await this.$http('smarthos.continuation.prescription.refuse', {
            id, cancelReason
        });
        return code === '0';
    }

    /**
     * 诊断置顶
     * @param diagnosisId
     * @returns {Promise<string>}
     */
    async diagnosisTop(diagnosisId) {
        const {code = ''} = await this.$http('smarthos.recipe.diagnosis.top', {
            diagnosisId
        });
        return code;
    }

    /**
     * 诊断取消置顶
     * @param diagnosisId
     * @returns {Promise<string>}
     */
    async diagnosisCancelTop(diagnosisId) {
        const {code = ''} = await this.$http('smarthos.recipe.diagnosis.cancel.top', {
            diagnosisId
        });
        return code;
    }

    /**
     * 诊断加标签
     * @param diagnosisId
     * @returns {Promise<string>}
     */
    async diagnosisTag(diagnosisId) {
        const {code = ''} = await this.$http('smarthos.recipe.diagnosis.tag', {
            diagnosisId
        });
        return code;
    }

    /**
     * 诊断取消标签
     * @param diagnosisId
     * @returns {Promise<string>}
     */
    async diagnosisCancelTag(diagnosisId) {
        const {code = ''} = await this.$http('smarthos.recipe.diagnosis.cancel.tag', {
            diagnosisId
        });
        return code;
    }

    /**
     * 已加标签诊断
     * @returns {Promise<*[]>}
     */
    async diagnosisDocList() {
        const {list = []} = await this.$http('smarthos.recipe.diagnosis.doc.list', {})
        return list
    }

    handlerItem(data) {
        data._sex = sexFilter(data.commpatGender || data.compatGender);
        data._replyType = RENEWAL_TYPE.find(r => r.id === data.replyType);
        data._replyTime = timeFormat(data.replyTime, '%Y/%m/%d %H:%M:%S');
        data._replyStatus = RENEWAL_ORDER_STATUS.find(r => r.id === data.replyStatus);
        if (data.historyRecipeOrder) {
            data.historyRecipeOrder._hisCreateTime = timeFormat(data.historyRecipeOrder.createTime, '%Y/%m/%d');
            data.historyRecipeOrder._sex = sexFilter(data.commpatGender);
        }
        return data;
    }
}

export const recipeService = new RecipeService();
